import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'wyniger';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyDJtPJYGpl99SedNgx8ru44SMBm9Cfvx3k',
		authDomain: 'wyniger-6c083.firebaseapp.com',
		projectId: 'wyniger-6c083',
		storageBucket: 'wyniger-6c083.firebasestorage.app',
		messagingSenderId: '165909436914',
		appId: '1:165909436914:web:cb2221050acc09bc4df36b',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAIdFeamt97rF7wghGSNHrrOG4mOTvCdkw',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['ch'],
	gaId: '',
	facebookPixelId: '268622425330452',
	hasRecommendations: true,
	apiUrl: 'https://dean-and-david.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: false,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	defVenue: '67ac6234a1a308914a5d28e1',
	merchantId: '3000032178',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
